import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  // cloudia tenant will be fully renamed to tcp later, for now to risky for production
  static cloudiaLegacyTenantName = 'cloudia';

  addTenantToHeaders(headers: HttpHeaders): HttpHeaders {
    return headers.append('X-TENANT-ID', this.getTenant());
  }

  getTenant() {
    const tenantFromPath = this.getTenantFromPath();
    return tenantFromPath || TenantService.cloudiaLegacyTenantName;
  }

  getTenantFromPath() {
    return window.location.href.replace('//', '').split('/')[1].split('#')[0];
  }
}

export enum Tenant {
  cloudia = 'cloudia',
}
